export const subscriptionManagementApiHandler = {
  getSubscription: {
    method: "GET",
    path: () => `org-subscriptions-management`
  },
  payForSubscription: {
    method: "POST",
    path: () => `org-subscriptions-management`
  }
};